import { useLazyQuery } from '@apollo/client';
import { getWorkflow } from 'modules/workflows/ducks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { WorkflowType } from 'modules/workflows/enums';
import { Rule } from '../../RuleBuilder/types';
import { transformExitRulesResponse } from '../ExitRules.utils';
import { fetchExitRulesQuery } from '../api/exitRulesQueries';
import { ExitRulesResponse } from '../types';

export const useFetchExitRules = () => {
  const [exitRules, setExitRules] = useState<Rule[]>([]);
  const workflow = useSelector(getWorkflow);
  const { id: workflowId, workflowType } = workflow;

  const [fetchExitRules, { loading: isLoading, refetch, error }] = useLazyQuery(
    fetchExitRulesQuery,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (data?.workflow?.exitRules?.length > 0) {
          const rules = transformExitRulesResponse(data?.workflow as ExitRulesResponse)?.rules;
          setExitRules(rules);
        } else {
          setExitRules([]);
        }
      },
    },
  );
  useEffect(() => {
    if (workflowId) {
      fetchExitRules({
        variables: {
          workflowId,
          workflowType,
          includeArchived: workflowType === WorkflowType.PUBLISHED, // when we are in published workflow, we need to include archived rules and will filter out on the frontend for the exit rules to be mutated
        },
      });
    }
  }, [workflowId]);

  return {
    exitRules: exitRules.filter((x) => !x.archivedDate),
    allExitRules: exitRules,
    isLoading,
    refetch,
    error,
  };
};
